import axios from "axios";

// Use current window origin when available (same-origin, avoids CORS issues when
// app is served from custom domain like gf347.es). Fallback to env for SSR/build.
const ENV_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const BACKEND_URL = (typeof window !== "undefined" && window.location?.origin)
    ? window.location.origin
    : ENV_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    withCredentials: true,
    headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("gf_token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

export function formatApiError(err, fallback = "Ha ocurrido un error") {
    const d = err?.response?.data?.detail;
    if (!d) return err?.message || fallback;
    if (typeof d === "string") return d;
    if (Array.isArray(d)) {
        // Errores Pydantic 422 — los traducimos a algo legible para el usuario
        const FIELD_LABELS = {
            email: "email",
            telefono: "teléfono",
            nombre: "nombre",
            empresa: "empresa",
            tipo_cliente: "tipo de cliente",
            password: "contraseña",
        };
        return d.map((e) => {
            const field = Array.isArray(e?.loc) ? e.loc[e.loc.length - 1] : "";
            const label = FIELD_LABELS[field] || field || "";
            if (e?.type === "missing") return `Falta el campo "${label}"`;
            if (e?.type === "value_error" || e?.type === "string_type") return `${label}: ${e.msg || "valor no válido"}`;
            if (e?.type?.startsWith?.("email")) return `Email no válido`;
            return e?.msg || JSON.stringify(e);
        }).join(" · ");
    }
    return fallback;
}

export function formatEUR(v, digits = 0) {
    if (v === null || v === undefined || isNaN(v)) return "—";
    return new Intl.NumberFormat("es-ES", {
        style: "currency",
        currency: "EUR",
        minimumFractionDigits: digits,
        maximumFractionDigits: digits,
    }).format(v);
}

export function formatNum(v, digits = 2) {
    if (v === null || v === undefined || isNaN(v)) return "—";
    return new Intl.NumberFormat("es-ES", {
        minimumFractionDigits: digits,
        maximumFractionDigits: digits,
    }).format(v);
}

export function formatPct(v, digits = 1) {
    if (v === null || v === undefined || isNaN(v)) return "—";
    return new Intl.NumberFormat("es-ES", {
        style: "percent",
        minimumFractionDigits: digits,
        maximumFractionDigits: digits,
    }).format(v);
}

export const WHATSAPP_NUMBER = "34604080483";
export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}`;
